import {
  CarrierSpendOverTimeRequestSchema,
  CarrierSpendOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getCarrierSpendOverTime = {
  name: "getCarrierSpendOverTime" as const,
  input: CarrierSpendOverTimeRequestSchema,
  output: CarrierSpendOverTimeResponseSchema,
};
